































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class TextMoneyComponent extends Vue {
  @Prop(Function) onChange!: Function;
  @Prop(String) label!: string;
  @Prop(String) placeholder?: string;
  @Prop(Boolean) readonly?: boolean;
  @Prop(Boolean) disabled?: boolean;
  @Prop(Boolean) outlined?: boolean;
  @Prop(Boolean) clearable?: boolean;
  @Prop(Array) rules?: string;
  @Prop(Function) saveEnter!: Function;

  public value = 0;

  public options() {
    return {
      locale: 'pt-BR',
      prefix: 'R$',
      suffix: '',
      length: 11,
      precision: 2,
    };
  }
  public properties() {
    return {
      hint: '',
    };
  }

  @Watch('value')
  public newValue(newValue: number) {
    this.onChange(newValue);
  }
}
